import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

export const staticDataService = {
  getStaticData: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.static.getStaticData,
      payload,
      headers,
      hasErrorHandler,
    }),
  getHomePrivileges: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.static.getHomePrivileges,
      payload,
      headers,
      hasErrorHandler,
    }),
  getHomePopularLocations: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.static.getHomePopularLocations,
      payload,
      headers,
      hasErrorHandler,
    }),
  getHomePopularRoutes: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.static.getHomePopularRoutes,
      payload,
      headers,
      hasErrorHandler,
    }),
  getHomeCityGuide: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.static.getHomeCityGuide,
      payload,
      headers,
      hasErrorHandler,
    }),
  getHomeLatestDeals: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.static.getHomeLatestDeals,
      payload,
      headers,
      hasErrorHandler,
    }),
};
